import {
  VUE_APP_MASTER_FRONTEND_URL,
} from "../config";
const domainAccessPath = ()=>{
    let hostname = window.location.hostname;
    const parts = hostname.split('.');
    if (parts.length > 2) {
        return `.${parts.slice(-2).join('.')}`;
    }    
  return `.${hostname}`;
} 
export const setTokenMasterCookie = (token) => {
    try {
        const now = new Date();
        now.setFullYear(now.getFullYear() + 1);
        const domainAccess = domainAccessPath();
        document.cookie = `tokenMaster=${token};expires=${now.toUTCString()};domain=${domainAccess};path=/`;
    } catch (error) {
        console.log(error)
        throw new Error(`Ocurrió el siguiente error al insertar la cookie tokenMaster`)
    }
}

export const getCookie = (cname)=>{
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
        c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
    }
    }
    return "";
}

export const setBackendURLCookie = ( {content: { BackendUrl } } ) => {
    try {
        const now = new Date();
        now.setFullYear(now.getFullYear() + 1);
        const domainAccess = domainAccessPath();
        document.cookie = `BackendUrl =${decodeURIComponent(BackendUrl)};expires=${now.toUTCString()};domain=${domainAccess};path=/`;
    } catch (error) {
        throw new Error(`Ocurrió el siguiente error al insertar la cookie "BackendUrl"`)
    }
}

export const setIDKeyMasterCookie = ( {content: { ID_KeyMaster } } ) => {
    try {
        const now = new Date();
        now.setFullYear(now.getFullYear() + 1);
        const domainAccess = domainAccessPath();
        document.cookie = `ID_KeyMaster=["${decodeURIComponent(ID_KeyMaster)}"];expires=${now.toUTCString()};domain=${domainAccess};path=/`;
    } catch (error) {
        throw new Error(`Ocurrió el siguiente error al insertar la cookie "ID_KeyMaster"`)
    }
}

export const redirectToMaster = () => {
    deleteCookie('frontendUrl')
    deleteCookie('BackendUrl')
    deleteCookie('tokenMaster')
    window.location.href = `${VUE_APP_MASTER_FRONTEND_URL}?redirect=1`;
}

export const deleteCookie = (name, path = '/') => {
    const domainAccess = domainAccessPath();
    let cookieString = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=${domainAccess};path=${path};`;
    
    document.cookie = cookieString;
}